<template>
  <div class="uploadVoucher">
    <div class="uploadBox">
      <div class="textarea">
        <el-input type="textarea" v-model="textvalue"></el-input>
      </div>
      <div class="imguploadBox">
        <div v-for="(imgUrl, index) in imgUrls" :key="index" class="imgbox">
          <i class="el-icon-close" @click="delimg(img)"></i>
          <img v-if="imgUrl.img" :src="imgUrl.img" alt @click.stop="clickimg(index)" />
        </div>
        <el-upload
          action=""
          list-type="picture-card"
          :limit="9"
          :http-request="uploadFile"
          multiple
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
    </div>
    <div class="tagbox">
      <div>
        <img src="@/assets/partyreports/scpz-icon1.png" alt="" />
        {{ dataList.headline }}
      </div>
      <div>
        <img src="@/assets/partyreports/scpz-icon2.png" alt="" />
        {{ dataList.address }}
      </div>
      <div>
        <img src="@/assets/partyreports/scpz-icon3.png" alt="" />
        活动时间：{{ dataList.startActivityTime | hoursTime }} -
        {{ dataList.endActivityTime | hoursTime }}
      </div>
    </div>

    <div class="submit" @click="submit">确认提交</div>

    <!-- 提交成功 -->
    <el-dialog :visible.sync="submitVisible" class="dialog">
      <div class="dialog-imgbox">
        <img src="@/assets/partyreports/tc-icon.png" alt="" />
        <div class="dialog-title">
          <p>活动上传凭证提交成功！</p>
          <p>等待管理员审核</p>
        </div>
        <div class="button" @click="toPartyReport">返回首页</div>
      </div>
    </el-dialog>

    <!-- //图片预览 -->
    <el-dialog title="" :visible.sync="imgDialogVisible" class="dialogimg">
      <div >
        <img :src="dialogImageUrl" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textvalue: "",
      dialogImageUrl: "",
      dialogVisible: false,
      submitVisible: false,
      imgDialogVisible:false,
      dataList: {},
      imgUrls: [],
    };
  },
  methods: {
    toPartyReport() {
      this.$router.push({
        path: '/partyReport',
        query: { title: '东坡志愿服务活动' },
      })
    },
    uploadFile(file) {
      let _this = this;
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = function () {
        _this.compressImg(reader.result, 500, 0.8);
        // _this.imgUrls.push({ img: reader.result });
      };
    },
    delimg(index) {
      this.imgUrls.splice(index, 1);
    },
    submit() {
      if (this.textvalue != "") {
        let string = "";
        this.imgUrls.filter((item) => {
          string = string + item.img.replace(/data(\S*?)base64,/, "") + ";";
        });
        let params = {
          vid: this.dataList.id,
          userid: parseInt(sessionStorage.getItem("c2userid")),
          memo: this.textvalue,
          photo: string,
        };
        this.axios
          .post("/api/VolunteerActivity/AddVoucher", params)
          .then((res) => {
            if (res.data.code == 0) {
              this.textvalue = "";
              this.imgUrls = [];
              this.submitVisible = true;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                offset: 300,
              });
            }
          });
        console.log(params);
      } else {
        this.$message({
          message: "请输入内容",
          type: "error",
          offset: 300,
        });
      }
    },
    compressImg(base64String, w, quality) {
      //压缩图片
      let _this = this;
      var getMimeType = function (urlData) {
        var arr = urlData.split(",");
        var mime = arr[0].match(/:(.*?);/)[1];
        return mime;
      };
      var newImage = new Image();
      var imgWidth, imgHeight;

      var promise = new Promise((resolve) => (newImage.onload = resolve));
      newImage.src = base64String;
      return promise.then(() => {
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL(getMimeType(base64String), quality);
        // console.log(base64);
        // // return base64;
        _this.imgUrls.push({ img: base64 });
      });
    },
    clickimg(index){
      this.dialogImageUrl = this.imgUrls[index].img;
      this.imgDialogVisible = true;
    }
  },
  created() {
    this.dataList = this.$route.query.item;
  },
};
</script>

<style lang="scss" scoped>
.uploadVoucher {

  .dialogimg {
    img {
      width: 100%;
    }
  }

  .uploadBox {
    margin: 0.38rem 0 0.55rem;
  }
  .imguploadBox {
    .imgbox {
      i {
        position: absolute;
        right: 0.15rem;
        top: 0;
        background-color: #c0ccda;
      }
      img {
        width: 2.2rem;
        height: 2.2rem;
        margin: 0 0.16rem 0.08rem 0;
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
      }
      position: relative;
    }
    display: grid;
    grid-template-columns: repeat(3, 33%);
    margin-top: 0.5rem;
  }

  .tagbox {
    div {
      img {
        width: 0.22rem;
        height: 0.22rem;
        margin: 0 0.1rem;
      }
      height: 0.4rem;
      background: #e9e9e9;
      border-radius: 0.2rem;
      font-size: 0.24rem;
      font-weight: 500;
      color: #999999;
      line-height: 0.4rem;
      margin-bottom: 0.2rem;
      padding-right: 0.2rem;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;
  }

  .submit {
    width: 4.6rem;
    height: 0.76rem;
    background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
    box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
    border-radius: 0.08rem;
    font-weight: 500;
    color: #f6f5f8;
    line-height: 0.76rem;
    text-align: center;
    margin: 0 auto 0.8rem;
  }

  .dialog {
    &-imgbox {
      img {
        width: 1.74rem;
        height: 1.74rem;
        border-radius: 50%;
      }
    }
    &-title {
      > p:nth-of-type(1) {
        font-size: 0.26rem;
        font-weight: 500;
        color: #666666;
        margin-bottom: 0.1rem;
      }
      > p:nth-of-type(2) {
        font-size: 0.3rem;
        font-weight: 500;
        color: #333333;
        margin-bottom: 0.3rem;
      }
    }
    .button {
      width: 2.85rem;
      height: 0.76rem;
      background: linear-gradient(-70deg, #fe7b49 0%, #fa705b 100%);
      border-radius: 0.08rem;
      text-align: center;
      font-size: 0.3rem;
      font-weight: 500;
      color: #f6f5f8;
      line-height: 0.76rem;
      margin: 0 auto 0;
    }
    // padding-bottom: 0.71rem;
  }
  /deep/.el-textarea__inner {
    border: none;
    background-color: #e9e9e9;
    height: 4.51rem;
    color: black;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 2.2rem;
    height: 2.2rem;
    margin: 0 0.16rem 0.08rem 0;
    display: none;
  }
  /deep/.el-upload--picture-card {
    width: 2.2rem;
    height: 2.2rem;
    line-height: 2.2rem;
  }
  /deep/.el-dialog {
    width: 70%;
    text-align: center;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item-actions:hover {
    display: none;
  }
  padding: 1.2rem 0.2rem 0;
  font-size: 0.3rem;
}
</style>